export interface IBranchContactsModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  first_name?: string;
  last_name?: string;
  profile?: string;
  email?: string;
  phone?: any;
  whatsapp_no?: string;
  enable_email_notification?: boolean;
  function?: string;
  created_by?: string;
  updated_by?: string;
  branch?: any;
}

export interface BranchContactsError {
  id?: string[];
  updated_at?: string[];
  created_at?: string[];
  is_active?: string[];
  first_name?: string[];
  last_name?: string[];
  profile?: string[];
  email?: string[];
  phone?: string[];
  whatsapp_no?: string[];
  enable_email_notification?: string[];
  function?: string[];
  created_by?: string[];
  updated_by?: string[];
  branch?: string[];
}
export class BranchContactsModel {
  id?: string;
  updated_at?: Date;
  created_at?: Date;
  is_active?: boolean;
  first_name?: string;
  last_name?: string;
  profile?: string;
  email?: string;
  phone?: any;
  whatsapp_no?: string;
  enable_email_notification?: boolean;
  function?: string;
  created_by?: string;
  updated_by?: string;
  branch?: any;

  error: BranchContactsError;

  constructor() {
    this.id = null;
    this.updated_at = null;
    this.created_at = null;
    this.is_active = true;
    this.first_name = null;
    this.last_name = null;
    this.profile = null;
    this.email = null;
    this.phone = null;
    this.whatsapp_no = null;
    this.enable_email_notification = false;
    this.function = null;
    this.created_by = null;
    this.updated_by = null;
    this.branch = null;

    this.resetErrors()
  }

  resetErrors() {
    this.error = {
      id: [],
      updated_at: [],
      created_at: [],
      is_active: [],
      first_name: [],
      last_name: [],
      profile: [],
      email: [],
      phone: [],
      whatsapp_no: [],
      enable_email_notification: [],
      function: [],
      created_by: [],
      updated_by: [],
      branch: [],
    }
  }

  savePayloadToModel(data: IBranchContactsModel) {
    this.id = data.id;
    this.updated_at = data.updated_at;
    this.created_at = data.created_at;
    this.is_active = data.is_active;
    this.first_name = data.first_name;
    this.last_name = data.last_name;
    this.profile = data.profile;
    this.email = data.email;
    this.phone = data.phone;
    this.whatsapp_no = data.whatsapp_no;
    this.enable_email_notification = data.enable_email_notification;
    this.function = data.function;
    this.created_by = data.created_by;
    this.updated_by = data.updated_by;
    this.branch = data.branch;
  }

  getSavePayload(): IBranchContactsModel {
    return {
      is_active: this.is_active,
      first_name: this.first_name,
      last_name: this.last_name,
      profile: this.profile,
      email: this.email,
      phone: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
      whatsapp_no: typeof this.phone == 'object' && this.phone != null ? this.phone.as_e164 : this.phone,
      enable_email_notification: this.enable_email_notification,
      function: this.function,
      branch: typeof this.branch == 'object' && this.branch != null ? this.branch.id : this.branch,
    }
  }
}